import { Component, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { REQUEST_COLORS } from 'src/app/request-v2/constants/request-colors.constants';

@Component({
    selector: 'app-color-selector',
    templateUrl: './color-selector.component.html',
    styleUrls: ['./color-selector.component.scss'],
})
export class ColorSelectorComponent {
    @Input() isVisible = false;

    @Input() selectedColor: string;

    @Input() colors: string[] = REQUEST_COLORS;

    @Output() colorSelect = new EventEmitter<string>();

    @Output() close = new EventEmitter<void>();

    constructor(private elementRef: ElementRef) {}

    @HostListener('document:click', ['$event'])
    handleClickOutside(event: MouseEvent): void {
        const clickedInside = this.elementRef.nativeElement.contains(event.target);
        if (!clickedInside && this.isVisible) {
            this.close.emit();
        }
    }

    onColorSelect(color: string, event: Event): void {
        this.colorSelect.emit(color);
        event.stopPropagation();
    }
}
